<script setup>
</script>

<template>
  <div>
    <slot></slot>
  </div>
</template>
